module.exports = __webpack_public_path__ + "static/img/yx-erzhong.d90b74e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yx-erzhong.png
// module id = HHLD
// module chunks = 0